import { defineStore } from 'pinia'
import axios from 'crypto-fetch/axios'

export const useMatchLabelsStore = defineStore('matchLabels', {
  state: () => ({
    matchLabels: []
  }),
  getters: {
    matchLabelsMap() {
      return this.matchLabels.reduce((obj, x) => {
        const { leagueFilterTabName, littleLabelUrl, newSortMap } = x
        if (leagueFilterTabName) {
          obj[leagueFilterTabName] = {
            leagueFilterTabName,
            littleLabelUrl,
            newSortMap
          }
        }
        return obj
      }, {})
    }
  },
  actions: {
    setMatchLabels(data = []) {
      this.matchLabels = data.map((x, i) => ({ ...x, index: i }))
    },
    async getMatchLabelsInfo(sportId = '') {
      const params = sportId ? `?sportId=${sportId}` : ''
      const data = await axios.get(`/facts-center/query/frontend/countries-a-z-menu/matchLabels${params}`)
      if (data) {
        this.setMatchLabels(data)
      }
    }
  }
})

// 获取对应 match label 的 tournamentIds
export const getMatchLabelLeagueIds = (label = '', sportId = '') => {
  const { matchLabelsMap } = useMatchLabelsStore()
  const labelConfig = matchLabelsMap[label]
  if (labelConfig) {
    const { newSortMap } = labelConfig
    const sportConfig = newSortMap[sportId]
    if (sportConfig && sportConfig[0]) {
      const { tournamentIds = [] } = sportConfig[0]
      return tournamentIds
    }
  }
}

// configKey 有两个值: commonLabeUrl, littleLabelUrl; all 表示是否返回 label config 对象
export const getLabelIcon = ({ configKey = '', displayIn = '', all = false, sportId, tournamentId, eventStatus }) => {
  const validList = getValidMatchLabelList(sportId, tournamentId, eventStatus)
  // 筛选位置
  const validDisplayList = validList.filter((x) => x.displayInList.includes(displayIn))
  if (!validDisplayList.length) {
    return ''
  }

  const data = validDisplayList.find((x) => !!x[configKey])
  if (data) {
    return !all ? data[configKey] : data
  } else {
    return ''
  }
}

const getSubBizType = (eventStatus) => {
  if (eventStatus === 0 || eventStatus === 7) {
    // prematch
    return 3
  } else if (eventStatus === 1 || eventStatus === 2) {
    // live
    return 1
  }
  return undefined
}

// 获取有效的 match labels 列表
const getValidMatchLabelList = (sportId, tournamentId, eventStatus) => {
  const { matchLabels } = useMatchLabelsStore()
  return matchLabels.filter((x) => {
    const sportList = x.newSortMap[sportId]
    if (!sportList) {
      return false
    }
    const subBizType = getSubBizType(eventStatus)
    return !!sportList.find((item) => {
      return item.tournamentIds.includes(tournamentId) && ((!eventStatus && eventStatus !== 0) || (item.subBizType.length && item.subBizType.includes(subBizType)))
    })
  })
}
